<template>
  <CareersSection :title="$t('startup.steps.title')" :eyebrow="$t('startup.steps.eyebrow')" section-id="steps-section">
    <div
      class="grid grid-cols-1 items-center gap-4 xs:grid-cols-2 sm:grid-cols-3 lg:flex lg:flex-row lg:items-start lg:justify-center lg:gap-8"
    >
      <CareersStep
        v-for="index of 5"
        :key="$t(`startup.steps.items.${index}`)"
        :number="index"
        :title="$t(`startup.steps.items.${index}`)"
        class="line"
      />
    </div>
  </CareersSection>
</template>

<style scoped>
@media screen(lg) {
  .line::before {
    content: '';
    position: absolute;
    top: 72px;
    left: -100px;
    width: 170px;
    height: 2px;
    background: #a9e7e2;
    z-index: -1;
  }

  .line:first-child::before {
    display: none;
  }
}
</style>
